import type { Observable } from 'rxjs';
import type { RgbColorHex } from './shared-ui-color-hex';
import type { ColorPalette } from './shared-ui-color-palette.types';
import type {
    PrettyFeelSharedUiColorName,
    SharedUiBackgroundColorDerivation,
    SharedUiBackgroundColorName,
    SharedUiColorDerivation,
    SharedUiColoredBackgroundColorDerivation,
    SharedUiColorName,
    SharedUiColorNameV2,
    SharedUiTextColorDerivation
} from './shared-ui-colors.types';

export interface SharedUiColorOptions {
    derivation?: SharedUiColorDerivation;
}

export interface SharedUiColoredBackgroundColorOptions {
    color: SharedUiColorName;
    derivation?: SharedUiColoredBackgroundColorDerivation;
}

export interface SharedUiBackgroundColorOptions {
    color?: SharedUiBackgroundColorName;
    derivation?: SharedUiBackgroundColorDerivation;
}

export abstract class SharedUiColorsService {
    abstract getColor$(colorName: SharedUiColorName, options?: SharedUiColorOptions): Observable<RgbColorHex>;

    abstract getBackgroundColor$(options: SharedUiBackgroundColorOptions): Observable<RgbColorHex>;
    abstract getTextColor$(
        derivation?: SharedUiTextColorDerivation,
        backgroundOptions?: SharedUiBackgroundColorOptions
    ): Observable<RgbColorHex>;
    abstract getColoredTextColor$(
        colorName: SharedUiColorName,
        backgroundOptions?: SharedUiBackgroundColorOptions
    ): Observable<RgbColorHex>;
    abstract getStrokeColor$(backgroundOptions?: SharedUiBackgroundColorOptions): Observable<RgbColorHex>;

    abstract getColoredBackgroundColor$(options: SharedUiColoredBackgroundColorOptions): Observable<RgbColorHex>;
    abstract getTextColorOnColoredBackground$(backgroundOptions: SharedUiColoredBackgroundColorOptions): Observable<RgbColorHex>;

    abstract getColorPalette(color: SharedUiColorNameV2 | PrettyFeelSharedUiColorName): ColorPalette;
    abstract getAllPrettyFeelColorPalette(): ColorPalette[];
}
